import React, { useContext } from "react";
import { Drawer, DrawerHeaderLeft } from "./Appbar";
import {
	Box,
	Avatar,
	Divider,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Typography,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LanguageSwitcher from "../../../LanguageSwitcher";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Logotipo from "../../../assets/Logotipo.svg";
import { GlobalContext } from "../../../GlobalContext";
import SettingsIcon from "@mui/icons-material/Settings";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import PersonIcon from "@mui/icons-material/Person";
import TuneIcon from "@mui/icons-material/Tune";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { BarChart } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CircularProgress from "@mui/material/CircularProgress";
import HomeIcon from "@mui/icons-material/Home";
import { auditPost } from "../../../api/config";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";

import DescriptionIcon from "@mui/icons-material/Description";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import axios from "axios";

const Left = () => {
	const {
		openLeft,
		handlerSideLeft,
		setAuthenticated,
		viewPermissions,
		user,
		getModuleId,
		openSubButtons,
		handlerSubButtons,
		site_id,
		isGranted,
	} = useContext(GlobalContext);

	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const moduleId = getModuleId("Login", "Log Out");

	// Verificar si todos los permisos están en false

	const isLoading = Object.values(viewPermissions).every((value) => value === false);

	const canViewDashboard = isGranted("Dashboard", "Ver el módulo de dashboard");

	const handleClick = () => {
		handlerSubButtons(!openSubButtons);
	};
	const apiAuth = axios.create({
		baseURL: process.env.REACT_APP_AUTH_URL,
		withCredentials: true, // Asegura que las cookies se envíen
	});

	const handleLogout = async () => {
		try {
			await auditPost(moduleId, site_id);
			await apiAuth.post("/user/logout");

			localStorage.clear();
			setAuthenticated(false);
		} catch (error) {
			console.error("Error durante el cierre de sesión:", error);
		}
	};

	return (
		<Drawer variant="permanent" open={openLeft}>
			<DrawerHeaderLeft
				sx={{
					px: 1.5,
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					gap: 1,
				}}
			>
				<Box
					sx={{
						flex: 1, // ✅ ocupa todo el espacio disponible
						height: 44, // alto del header del logo
						display: "flex",
						alignItems: "center",
					}}
				>
					<Box
						component="img"
						src={Logotipo}
						alt="logo-app"
						sx={{
							width: "100%",
							height: "100%",
							objectFit: "contain", // ✅ escala sin deformar
						}}
					/>
				</Box>

				<IconButton
					onClick={() => handlerSideLeft(!openLeft)}
					sx={{
						bgcolor: "primary.dark",
						"&:hover": { bgcolor: "primary.dark" },
						borderRadius: 2,
					}}
				>
					<ChevronLeftIcon sx={{ color: "#fff" }} />
				</IconButton>
			</DrawerHeaderLeft>

			<Divider />
			{isLoading ? (
				<Box
					sx={{
						mt: 4,
						width: "100%",
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<CircularProgress color="primary" />
				</Box>
			) : (
				<>
					<List>
						<ListItemButton
							sx={{ pl: 2.5 }}
							selected={location.pathname === "/home"}
							onClick={() => navigate("/home")}
						>
							<ListItemIcon>
								<HomeIcon />
							</ListItemIcon>
							<ListItemText primary={t("aux.home")} />
						</ListItemButton>

						{viewPermissions.simulation && (
							<ListItemButton
								sx={{ pl: 2.5 }}
								selected={location.pathname === "/simulation"}
								onClick={() => navigate("/simulation")}
							>
								<ListItemIcon>
									<TuneIcon />
								</ListItemIcon>

								<ListItemText primary={t("sim.title")} />
							</ListItemButton>
						)}

						{canViewDashboard && (
							<ListItemButton
								sx={{ pl: 2.5 }}
								selected={location.pathname === "/dashboard"}
								onClick={() => navigate("/dashboard")}
							>
								<ListItemIcon>
									<BarChart />
								</ListItemIcon>
								<ListItemText primary={t("charts.title_dashboard")} />
							</ListItemButton>
						)}

						{viewPermissions.config && (
							<ListItemButton onClick={handleClick} sx={{ pl: 2.5 }}>
								<ListItemIcon>
									<SettingsIcon />
								</ListItemIcon>
								<ListItemText primary={t("config.title")} />
								{openSubButtons ? <ExpandLess /> : <ExpandMore />}
							</ListItemButton>
						)}

						{viewPermissions.config && (
							<Collapse in={openSubButtons} timeout="auto" unmountOnExit>
								<List component="div" disablePadding>
									<ListItemButton
										sx={{
											px: 4,
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
										selected={location.pathname === "/config/configedit"}
										onClick={() => {
											navigate("/config/configedit");
										}}
									>
										<ListItemIcon
											sx={{
												minWidth: "32px",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
											}}
										>
											<DescriptionIcon fontSize="small" />
										</ListItemIcon>
										<ListItemText
											primary={
												<Typography variant="body1" align="center">
													{t("config.edit_contract.title")}
												</Typography>
											}
										/>
									</ListItemButton>
								</List>
							</Collapse>
						)}
						{viewPermissions.config && (
							<Collapse in={openSubButtons} timeout="auto" unmountOnExit>
								<List component="div" disablePadding>
									<ListItemButton
										sx={{
											px: 4,
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
										selected={location.pathname === "/config/configeditsite"}
										onClick={() => navigate("/config/configeditsite")}
									>
										<ListItemIcon
											sx={{
												minWidth: "32px",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
											}}
										>
											<EditLocationAltIcon fontSize="small" />
										</ListItemIcon>
										<ListItemText
											primary={
												<Typography variant="body1" align="center">
													{t("config.edit_site.title")}
												</Typography>
											}
										/>
									</ListItemButton>
								</List>
							</Collapse>
						)}

						{viewPermissions.upload && (
							<ListItemButton
								sx={{ pl: 2.5 }}
								selected={location.pathname === "/upload"}
								onClick={() => navigate("/upload")}
							>
								<ListItemIcon>
									<FileUploadIcon />
								</ListItemIcon>

								<ListItemText primary={t("upload.title")} />
							</ListItemButton>
						)}
						{viewPermissions.audit && (
							<ListItemButton
								sx={{ pl: 2.5 }}
								selected={location.pathname === "/audit"}
								onClick={() => navigate("/audit")}
							>
								<ListItemIcon>
									<ManageSearchIcon />
								</ListItemIcon>

								<ListItemText primary={t("audit.title")} />
							</ListItemButton>
						)}
						{viewPermissions.execute && (
							<ListItemButton
								sx={{ pl: 2.5 }}
								selected={location.pathname === "/execute"}
								onClick={() => navigate("/execute")}
							>
								<ListItemIcon>
									<PlayArrowIcon />
								</ListItemIcon>
								<ListItemText primary={t("sim_masive.title")} />
							</ListItemButton>
						)}

						{viewPermissions.execute && (
							<ListItemButton
								sx={{ pl: 2.5 }}
								selected={location.pathname === "/forecast"}
								onClick={() => navigate("/forecast")}
							>
								<ListItemIcon>
									<AccessTimeIcon />
								</ListItemIcon>
								<ListItemText primary={t("forecast.title")} />
							</ListItemButton>
						)}

						{viewPermissions.review && (
							<ListItemButton
								sx={{ pl: 2.5 }}
								selected={location.pathname === "/review"}
								onClick={() => navigate("/review")}
							>
								<ListItemIcon>
									<ContentPasteSearchIcon />
								</ListItemIcon>
								<ListItemText primary={t("review.title")} />
							</ListItemButton>
						)}
					</List>

					<List sx={{ position: "absolute", bottom: 0, width: "100%" }}>
						<LanguageSwitcher compact={!openLeft} />
						<Divider />

						<ListItem
							secondaryAction={
								openLeft ? (
									<IconButton onClick={handleLogout}>
										<ExitToAppIcon color="error" />
									</IconButton>
								) : null
							}
						>
							<ListItemIcon sx={{ ml: -0.5 }}>
								<Avatar>
									<PersonIcon />
								</Avatar>
							</ListItemIcon>

							<ListItemText primary={user} />
						</ListItem>
					</List>
				</>
			)}
		</Drawer>
	);
};

export { Left };
